import { type ReactElement, type ReactNode } from 'react';
import { Box, Text } from '@/ui';
import { TextField } from '@/ui/primitives/TextField';
import {
  projectCsvMappingFieldRowAdornmentSx,
  projectCsvMappingFieldRowInputSx,
  projectCsvMappingFieldRowLabelSx,
  projectCsvMappingFieldRowSx,
} from './ProjectCsvMappingFieldRow.styles';

type ProjectCsvMappingFieldRowProps = {
  label: string;
  value: string;
  placeholder: string;
  adornment: ReactNode;
  onChange: (nextValue: string) => void;
};

export const ProjectCsvMappingFieldRow = ({
  label,
  value,
  placeholder,
  adornment,
  onChange,
}: ProjectCsvMappingFieldRowProps): ReactElement => (
  <Box sx={projectCsvMappingFieldRowSx}>
    <Text role="body" sx={projectCsvMappingFieldRowLabelSx}>
      {label}
    </Text>
    <TextField
      fieldStyle="settings"
      value={value}
      placeholder={placeholder}
      onChange={(event) => {
        onChange(event.target.value);
      }}
      sx={projectCsvMappingFieldRowInputSx}
    />
    <Box sx={projectCsvMappingFieldRowAdornmentSx}>{adornment}</Box>
  </Box>
);
